// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xjFv","toggle":"styles_toggle__3rEUf","preview":"styles_preview__3Mfr6"};